// Single source of truth for user roles
// Add new roles here — UI dropdowns and TypeScript type update automatically

export const USER_ROLES = [
  { value: 'user', label: 'User', description: 'Regular user with basic access' },
  { value: 'doctor', label: 'Doctor', description: 'Can review AI reports and manage packages' },
  { value: 'support', label: 'Support', description: 'Can view users and generate auth codes' },
  { value: 'marketing', label: 'Marketing', description: 'Can access Tools page for email exports' },
  { value: 'admin', label: 'Admin', description: 'Full system access' },
] as const

// Derive the type from the array
export type UserRole = (typeof USER_ROLES)[number]['value']

// Simple options (value + label only)
export const ROLE_OPTIONS = USER_ROLES.map(({ value, label }) => ({ value, label }))

// Full options with descriptions
export const ROLE_OPTIONS_WITH_DESCRIPTION = USER_ROLES.map(({ value, label, description }) => ({
  value,
  label,
  description,
}))
